import { useEffect } from "react"

export type Tema = "giorno" | "serata"

/** Il passaggio in Serata non è un'impostazione, è uno stato del festival:
 *  scatta quando la serata va in diretta (DESIGN.md §4).
 *
 *  Vale anche per la regia: chi manda avanti la serata è nella stessa stanza
 *  buia degli altri, e un pannello a piena luminanza acceca lui per primo.
 */
export function useTema(inDiretta: boolean, manuale: Tema | null = null): void {
  useEffect(() => {
    const sistema: Tema = matchMedia("(prefers-color-scheme: dark)").matches ? "serata" : "giorno"
    document.documentElement.dataset.tema = manuale ?? (inDiretta ? "serata" : sistema)
  }, [inDiretta, manuale])
}
